module.exports = __webpack_public_path__ + "img/banner-telesalud3-mobile.405664f4.png";